<template>
    <div :class="$style.loader">
        <div :class="$style.bar"></div>
        <div :class="$style.bar"></div>
        <div :class="$style.bar"></div>
        <div :class="$style.bar"></div>
    </div>
</template>

<script>
    export default {
        name: "DefaultLoader",
        props: {
            background: null
        }
    }
</script>

<style lang="scss" module>
    @import '../../scss/variables/variables';

    .loader {
        display: inline-block;
        margin: 0 .15em 0 0;
    }

    .bar {
        display: inline-block;
        width: .25em;
        height: .9em;
        border-radius: 4px;
        animation: loading 1s ease-in-out infinite;
    }

    .bar:nth-child(1) {
        background-color: currentColor;
        animation-delay: 0;
    }

    .bar:nth-child(2) {
        background-color: currentColor;
        animation-delay: 0.09s;
    }

    .bar:nth-child(3) {
        background-color: currentColor;
        animation-delay: .18s;
    }

    .bar:nth-child(4) {
        background-color: currentColor;
        animation-delay: .27s;
    }

    @keyframes loading {
        0% {
            transform: scale(1);
        }
        20% {
            transform: scale(1, 1.8);
        }
        40% {
            transform: scale(1);
        }
    }
</style>